<template>
  <div>
    <nav-bar />
    <nav class="filter-button-group">
      <div class="px-0 mx-0 justify-content-start">
        <div class="input-group col-6">
          <div class="btn-group mr-3" role="group" aria-label="Basic outlined example">
            <button type="button" :class="`btn ${mode === 'settings' ? 'btn-secondary' : 'btn-outline-secondary'}`"
              @click="setMode('settings')">{{ $t('Settings') }}</button>
            <button type="button" :class="`btn ${mode === 'logs' ? 'btn-secondary' : 'btn-outline-secondary'}`"
              @click="setMode('logs')">{{ $t('Logs') }}</button>
            <button type="button" :class="`btn ${mode === 'reports' ? 'btn-secondary' : 'btn-outline-secondary'}`"
              @click="setMode('reports')">{{ $t('Reports') }}</button>
          </div>
        </div>
      </div>
    </nav>

    <div v-if="mode === 'settings'" class="container pt-4">
      <div class="row">
        <div class="col-12 col-lg-6">
          <div class="card">
            <div class="kne-title card-header">
              <h3 class="my-2">{{ $t('Settings.modifyInfo.title') }}</h3>
            </div>

            <!-- Change info -->
            <div class="card-block">
              <div class="row">
                <regular-input :disabled="!isAdmin || isViewer" :value="user.name" @input="user.name = $event" type="text"
                  :placeholder="$t('Settings.modifyInfo.companyName') + '*'" class="col-12 col-md-6 form-group" />
                <regular-input :disabled="!isAdmin || isViewer" :value="user.address" @input="user.address = $event" type="text"
                  :placeholder="$t('Settings.modifyInfo.address') + '*'" class="col-12 col-md-6 form-group" />
              </div>

              <div class="row">
                <regular-input :disabled="!isAdmin || isViewer" :value="user.city" @input="user.city = $event" type="text"
                  :placeholder="$t('Settings.modifyInfo.city') + '*'" class="col-12 col-md-6 form-group" />
                <regular-input :disabled="!isAdmin || isViewer" :value="user.postcode" @input="user.postcode = $event" type="text"
                  :placeholder="$t('Settings.modifyInfo.zipCode') + '*'" class="col-12 col-md-6 form-group" />
              </div>

              <div class="row">
                <regular-select :disabled="!isAdmin || isViewer" :value="user.province" @change="user.province = $event" type="text"
                  :placeholder="$t('Settings.modifyInfo.province') + '*'" class="col-12 col-md-6 form-group">
                  <option v-for="province in provinces">{{ province }}</option>
                </regular-select>
                <regular-input :disabled="!isAdmin || isViewer" :value="user.phone" @input="user.phone = $event" type="text"
                  :placeholder="$t('Settings.modifyInfo.phone') + '*'" class="col-12 col-md-6 form-group" />
              </div>
              <div class="row">
                <regular-input :disabled="!isAdmin || isViewer" :value="user.nir" @input="user.nir = $event" type="text"
                  :placeholder="$t('Settings.modifyInfo.NIR') + '*'" class="col-12 col-md-6 form-group" />
                <regular-input :disabled="!isAdmin || isViewer" :value="user.tps" @input="user.tps = $event" type="text"
                  :placeholder="$t('Settings.modifyInfo.GST')" class="col-12 col-md-6 form-group" />
              </div>

              <div class="row">
                <regular-input :disabled="!isAdmin || isViewer" :value="user.tvq" @input="user.tvq = $event" type="text"
                  :placeholder="$t('Settings.modifyInfo.QST')" class="col-12 col-md-6 form-group" />
                <regular-input :disabled="!isAdmin || isViewer" :value="user.cigle" @input="user.cigle = $event" type="text"
                  :placeholder="$t('Settings.modifyInfo.cigle') + '*'" class="col-12 col-md-6 form-group" />
              </div>

              <div class="row">
                <regular-input :disabled="!isAdmin || isViewer" :value="user.fax" @input="user.fax = $event" type="text"
                  :placeholder="$t('Settings.modifyInfo.fax')" class="col-12 col-md-6 form-group" />
                <regular-input :disabled="!isAdmin || isViewer" :value="user.email" @input="user.email = $event" type="text"
                  :placeholder="$t('Settings.modifyInfo.email')" class="col-12 col-md-6 form-group" />
                <regular-input-file :disabled="!isAdmin || isViewer" name="logo" @input="user.logo = $event"
                  :placeholder="$t('Settings.modifyInfo.logo')" class="col-12 col-md-6 form-group" />
              </div>

              <img id='logo' :src="user.logo" class="m-1 img-fluid mini">

              <div class="row">
                <regular-checkbox :checked="user.driverComment" @change="user.driverComment = $event"
                  :label="$t('Settings.modifyInfo.driverComment')" class="col-12" />
                <div class="col-12">
                  <button class="btn btn-kne-orange w-100" :disabled="!modifyFormFilled || !isAdmin"
                    @click="submitInfo()">{{ $t('Settings.modifyInfo.submit') }}</button>
                </div>
              </div>

              <div class="mt-3">
                <small>* {{ $t('Settings.modifyInfo.disclaimer') }}</small>
              </div>

            </div>

          </div>

          <div class="card mt-3">
            <div class="kne-title card-header">
              <h3 class="my-2">{{ $t('Settings.modifyGeotabCredentials.title') }}</h3>
            </div>
            <div class="card-block">
              <div class="row">
                <regular-input :disabled="!hasFullAccess || !isAdmin || isViewer" :value="geotabCredentials.userName"
                  @input="geotabCredentials.userName = $event" type="text"
                  :placeholder="$t('Settings.modifyGeotabCredentials.userName') + '*'" class="col-12 form-group" />
                <div class="form-group password-group col-12">
                  <input style="width: 100%;" :disabled="!hasFullAccess || !isAdmin || isViewer" :value="geotabCredentials.password"
                    @input="geotabCredentials.password = $event.target.value" :type="showPassword ? 'text' : 'password'"
                    :placeholder="$t('Settings.modifyGeotabCredentials.password') + '*'"
                    class="col-12 form-control input-password" />
                  <button :disabled="!hasFullAccess || !isAdmin || isViewer" type="button" class="eye-button"
                    @click="showPassword = !showPassword">
                    <i :class="{ 'fa fa-eye-slash': !showPassword, 'fa fa-eye': showPassword }"></i>
                  </button>
                </div>
                <regular-input :disabled="!hasFullAccess || !isAdmin || isViewer" :value="geotabCredentials.database"
                  @input="geotabCredentials.database = $event" type="text"
                  :placeholder="$t('Settings.modifyGeotabCredentials.database') + '*'" class="col-12 form-group" />
                <div class="col-12">
                  <button class="btn btn-kne-orange w-100"
                    :disabled="!hasFullAccess || !isAdmin || modifyGeotabCredentials"
                    @click="submitGeotabCredentials()">{{ $t('Settings.modifyPass.submit') }}</button>
                </div>
              </div>
            </div>
          </div>

          <div class="card mt-3">
            <div class="kne-title card-header">
              <h3 class="my-2">{{ $t('Settings.isZoneVerification.title') }}</h3>
            </div>
            <div class="card-block">
              <div class="row">
                <div class="col-6">
                  <input type="button" class="w-100 btn"
                    :class="{ 'btn-kne-darkgrey': !$store.state.userInfo.isZoneVerification, 'btn-kne-orange': $store.state.userInfo.isZoneVerification}"
                    @click="toggleZoneVerification(true)" :disabled="isViewer" :value="$t('Settings.isZoneVerification.enable')">
                </div>
                <div class="col-6">
                  <input type="button" class="w-100 btn"
                    :class="{ 'btn-kne-darkgrey': $store.state.userInfo.isZoneVerification, 'btn-kne-orange': !$store.state.userInfo.isZoneVerification }"
                    @click="toggleZoneVerification(false)" :disabled="isViewer" :value="$t('Settings.isZoneVerification.disable')">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-12 col-lg-6" id="changePass">

          <!-- Change password -->
          <div class="card">
            <div class="kne-title card-header">
              <h3 class="my-2">{{ $t('Settings.modifyPass.title') }}</h3>
            </div>
            <div class="card-block">
              <div class="row">
                <regular-input :value="changePass.email" @input="changePass.email = $event" type="text"
                  :placeholder="$t('Settings.modifyPass.email') + '*'" class="col-12 form-group" />
                <regular-input :value="changePass.oldPass" @input="changePass.oldPass = $event" type="password"
                  :placeholder="$t('Settings.modifyPass.oldPass') + '*'" class="col-12 form-group" />
                <regular-input :value="changePass.newPass" @input="changePass.newPass = $event" type="password"
                  :placeholder="$t('Settings.modifyPass.newPass') + '*'" class="col-12 form-group" />
                <regular-input :value="changePass.newPassConfirm" @input="changePass.newPassConfirm = $event"
                  type="password" :placeholder="$t('Settings.modifyPass.confirmPass') + '*'"
                  class="col-12 form-group" />
                <div class="col-12">
                  <button class="btn btn-kne-orange w-100"
                    :disabled="!modifyPasswordFormFilled || !passwordConfirmation || isViewer" @click="submitPass()">{{
                    $t('Settings.modifyPass.submit') }}</button>
                </div>
              </div>
            </div>
          </div>

          <!-- Change language -->
          <div class="card mt-3">
            <div class="kne-title card-header">
              <h3 class="my-2">{{ $t('Settings.modifyLang.title') }}</h3>
            </div>
            <div class="card-block">
              <div class="row">
                <div class="col-6">
                  <input type="button" class="w-100 btn"
                    :class="{ 'btn-kne-darkgrey': $store.state.i18n.locale === 'fr', 'btn-kne-orange': $store.state.i18n.locale === 'en' }"
                    @click="changeLang('en')" :disabled="isViewer" value="EN">
                </div>
                <div class="col-6">
                  <input type="button" class="w-100 btn"
                    :class="{ 'btn-kne-darkgrey': $store.state.i18n.locale === 'en', 'btn-kne-orange': $store.state.i18n.locale === 'fr' }"
                    @click="changeLang('fr')" :disabled="isViewer" value="FR">
                </div>
              </div>
            </div>
          </div>

          <!-- Change charge -->
          <div class="card mt-3">
            <div class="kne-title card-header">
              <h3 class="my-2">{{ $t('Settings.modify_fuel.title') }}</h3>
            </div>
            <div class="card-block">
              <div class="row">
                <regular-input :value="$store.state.userInfo.fuelCharge" @input="fuelCharge = $event" type="number"
                  :placeholder="$t('Settings.modify_fuel.fuel_input')" class="col-12 col-md-6 form-group" />
                <div class="col-6">
                  <input type="button" class="w-100 btn"
                    :class="{ 'btn-kne-darkgrey': $store.state.i18n.locale === 'en', 'btn-kne-orange': $store.state.i18n.locale === 'fr' }"
                    @click="confirmeChangeToUserinfo()" :disabled="isViewer" :value="$t('Settings.modifyPass.submit')">
                </div>
              </div>
            </div>
          </div>

          <!-- Change announcement -->
          <div class="card mt-3">
            <div class="kne-title card-header">
              <h3 class="my-2">{{ $t('Settings.modify_announcement.title') }}</h3>
              <i>{{ $t('Settings.modify_announcement.helper') }}</i>
            </div>

            <transition name="fade">
              <p v-show="isFeedbackPlay" id="feedbackMessage">{{ feedbackMessage }}</p>
            </transition>

            <div class="card-block">
              <!-- French -->
              <div>
                <h4>{{ $t('Settings.modify_announcement.fr_label') }}</h4>
                <p class=""><strong>{{ $t('Settings.modify_announcement.current_message') }}</strong>:
                  {{ savedAnnouncements.fr }}</p>
                <div class="">
                  <regular-textarea id="announcementFR" :value="announcementFR" @input="announcementFR = $event"
                    type="text" :placeholder="$t('Settings.modify_announcement.fr_placeholder')" class="form-group" />
                </div>
              </div>

              <!-- English -->
              <div class="mt-3">
                <h4>{{ $t('Settings.modify_announcement.en_label') }}</h4>
                <p><strong>{{ $t('Settings.modify_announcement.current_message') }}</strong>: {{ savedAnnouncements.en
                  }}
                </p>
                <regular-textarea id="announcementEN" :value="announcementEN" @input="announcementEN = $event"
                  type="text" :placeholder="$t('Settings.modify_announcement.en_placeholder')" class="form-group" />

                <button class="w-100 btn btn-kne-orange" :disabled="isViewer" @click="onAnnouncementSave(announcementFR, announcementEN)">{{
                  $t('Settings.modify_announcement.save') }}</button>
              </div>
            </div>
          </div>

          <div v-if="hasFullAccess && !isViewer" class="card mt-3">
            <a class="btn btn-kne-orange w-100" href="#/Zones">{{ $t('Settings.modify_zone.modify_zones') }}</a>
          </div>

        </div>
      </div>

      <!-- Modify price by vehicle classification -->
      <div class="card mt-3">
        <div class="kne-title card-header">
          <h3 class="my-2">{{ $t('Settings.modifyPriceByVehicleClassification.title') }}</h3>
        </div>
        <div class="card-block">
          <div class="row">
            <!-- Table Header -->
            <div class="form-group col-12 vehicle-classification-item mb-3">
              <div class="mb-2" style="width: 120px;">
                <strong>{{ $t('Settings.modifyPriceByVehicleClassification.category') }}</strong>
              </div>
              <div class="d-flex flex-row flex-wrap gap-4 fw-bold">
                <strong style="width: 180px;">{{ $t('Settings.modifyPriceByVehicleClassification.volumetricLower') }}</strong>
                <strong style="width: 180px;">{{ $t('Settings.modifyPriceByVehicleClassification.volumetricUpper') }}</strong>
                <strong style="width: 180px;">{{ $t('Settings.modifyPriceByVehicleClassification.realLower') }}</strong>
                <strong style="width: 180px;">{{ $t('Settings.modifyPriceByVehicleClassification.realUpper') }}</strong>
                <strong style="width: 180px;">{{ $t('Settings.modifyPriceByVehicleClassification.surplus') }}</strong>
              </div>
            </div>

            <!-- Table Rows -->
            <template v-for="(label, key) in vehicleCategories">
              <div class="form-group col-12 vehicle-classification-item mb-3">
                <!-- Category -->
                <div class="mb-2" style="width: 110px;">
                  <strong>{{ $t(`OrderCurrent.modal.${key}`) }}</strong>
                </div>

                <div class="d-flex flex-row flex-wrap gap-2">
                  <!-- Volumetric Lower Limit -->
                  <div style="width: 180px;">
                    <regular-input
                      :disabled="!hasFullAccess || !isAdmin || isViewer"
                      :value="priceByVehicleClassification[key].volumetricLower"
                      @input="priceByVehicleClassification[key].volumetricLower = $event"
                      type="number"
                      class="form-control-sm"
                      :placeholder="$t('Settings.modifyPriceByVehicleClassification.volumetricLower')"
                    />
                  </div>

                  <!-- Volumetric Upper Limit -->
                  <div style="width: 180px;">
                    <regular-input
                      :disabled="!hasFullAccess || !isAdmin || isViewer"
                      :value="priceByVehicleClassification[key].volumetricUpper"
                      @input="priceByVehicleClassification[key].volumetricUpper = $event"
                      type="number"
                      class="form-control-sm"
                      :placeholder="$t('Settings.modifyPriceByVehicleClassification.volumetricUpper')"
                    />
                  </div>

                  <!-- Real Lower Limit -->
                  <div style="width: 180px;">
                    <regular-input
                      :disabled="!hasFullAccess || !isAdmin || isViewer"
                      :value="priceByVehicleClassification[key].realLower"
                      @input="priceByVehicleClassification[key].realLower = $event"
                      type="number"
                      class="form-control-sm"
                      :placeholder="$t('Settings.modifyPriceByVehicleClassification.realLower')"
                    />
                  </div>

                  <!-- Real Upper Limit -->
                  <div style="width: 180px;">
                    <regular-input
                      :disabled="!hasFullAccess || !isAdmin || isViewer"
                      :value="priceByVehicleClassification[key].realUpper"
                      @input="priceByVehicleClassification[key].realUpper = $event"
                      type="number"
                      class="form-control-sm"
                      :placeholder="$t('Settings.modifyPriceByVehicleClassification.realUpper')"
                    />
                  </div>

                  <!-- Surplus -->
                  <div style="width: 180px;">
                    <regular-input
                      :disabled="!hasFullAccess || !isAdmin || isViewer"
                      :value="priceByVehicleClassification[key].surplus"
                      @input="priceByVehicleClassification[key].surplus = $event"
                      type="number"
                      class="form-control-sm"
                      :placeholder="$t('Settings.modifyPriceByVehicleClassification.surplus')"
                    />
                  </div>
                </div>
              </div>
            </template>

            <!-- Submit -->
            <div class="col-12">
              <button
                class="btn btn-kne-orange w-100"
                :disabled="!hasFullAccess || !isAdmin || isViewer"
                @click="submitPriceByVehicleClassification()"
              >
                {{ $t('Settings.modifyPass.submit') }}
              </button>
            </div>
          </div>
        </div>
      </div>


    </div>
    <div v-else-if="mode === 'logs'">
      <table-element :isShowFilter="true" :title="$t('logs.title')" :fields="fieldsObj" :arrOfElement="logs"
        :sortSpacing="0" class="card mx-2 my-3" @updateFilterResults="updateFilterResults">
        <template #header-actions>
        </template>

        <template #body-content-desktop="content">
          <!-- List of orders -->
          <tr v-for="(log, index) in content.results" class="table-element_hover text-center" :key="index">
            <td>{{ getUserName(log.UID) }}</td>
            <td>{{ $t('logs.action.' + log.action) }}{{ log.status ? ': ' + log.status : '' }}{{ log.targetName ? ': ' +
              log.targetName : ''}}</td>
            <td>{{ getDate(log.date) }}</td>
            <td>{{ log.orderID || log.modifiedUserName || log.customerName || log.targetName || log.createdUserName }}
            </td>
          </tr>
        </template>

        <template #body-content-mobile="content">
          <!-- List of orders -->
          <div v-for="(log, index) in content.results" class="card my-3 mx-2" :key="index">
            <div class="card-header m-2">
              <h4><strong>{{ getUserName(log.UID) }}</strong></h4>
              <p>{{ $t('logs.action.' + log.action) }}{{ log.status ? ': ' + log.status : '' }}{{ log.targetName ? ': '
                +
                log.targetName : ''}}</p>
              <p>{{ getDate(log.date) }}</p>
            </div>
            <div class="m-2">
              <p>{{ log.orderID || log.modifiedUserName || log.customerName || log.targetName || log.createdUserName }}
              </p>
            </div>
          </div>
        </template>
      </table-element>
    </div>
    <div v-else>
      <table-element
      :isShowFilter="true"
      :title="$t('Reports.title')"
      :fields="fieldsObj"
      :arrOfElement="deliveries"
      :sortSpacing="0"
      class="card mx-2 my-4"
    >
      <template #header-actions>
        <div class="text-center red-text mt-2">
          <i>{{$t('Reports.tooltip')}}</i>
        </div>

        <div class="search-wrapper p-2">
          <div class="search_element-container">
            <label for="driverAccounts">{{$t('Reports.driver_placeholder')}}</label>
            <model-select
              id="driverAccounts"
              :options="getDriverSelectOptions"
              v-model="reportsSearch.driver"
              :placeholder="$t('Reports.driver_placeholder')"
            />
          </div>

          <div class="date_search-container">
            <div class="w-100">
              <label for="dateFrom">{{$t('Reports.date_from')}}</label>
              <regular-input
              id="dateFrom"
              :value="reportsSearch.from"
              @input="reportsSearch.from = $event"
              type="date" :placeholder="$t('Reports.date_from')" class="form-group search_field"/>
            </div>

            <div class="w-100">
              <label for="dateTo">{{$t('Reports.date_to')}}</label>
              <regular-input
              id="dateTo"
              :value="reportsSearch.to"
              @input="reportsSearch.to = $event"
              type="date" :placeholder="$t('Reports.date_to')" class="form-group search_field"/>
            </div>
          </div>

          <!-- Button actions -->
          <div>
            <div class="button_search_container my-2">
              <button class="btn btn-kne-orange w-50 mx-5 my-2" @click="clear()">
                {{$t('Search.clear')}}
              </button>
              <custom-json-excel
                class="w-50 mx-5 my-2"
                :customerFields="customers_fields"
                :filterResults="deliveries"
                :name="'reports' + getDate(Date.now()) + '.xls'"
              />
            </div>

            <div class="mx-5">
              <button class="btn border w-100" :disabled="!filled" @click="onSearchSubmit()">
                {{$t('Search.submit')}}
              </button>
            </div>
          </div>
        </div>
      </template>

      <template #pre-body-content>
        <div class="my-3 text-center">
          <p>{{$t('OrderCurrent.count')}} {{deliveries.length}}</p>
          <p>{{reportsFeedbackMessage}}</p>
        </div>
      </template>

      <template #body-content-desktop="content">
        <!-- List of orders -->
        <tr v-for="(order, index) in content.results"
        class="table-element_hover text-center"
        :key="index"
        :class="{
          'drop': order.status === 'Drop',
          'cancel': order.status === 'Cancel',
          'waiting': order.status === 'Attente',
          'pick': order.status === 'Pick',
          'transit': order.status === 'Transit',
          'dispatch': order.status === 'Dispatch',
          'reject': order.status === 'Reject',
          'inspection': order.status === 'Inspection',
          'ordered': order.status === 'Transférée'
        }">
          <td class="nowrap">{{order.orderNb}}</td>
          <td class="nowrap">{{order.price}}$</td>
          <td class="nowrap">{{order.pickup}}</td>
          <td class="nowrap">{{order.delivery}}</td>
          <td class="nowrap">{{order.billing}}</td>
          <td class="nowrap"><p class="table-fix-width">{{translatedStatus(order.status)}}</p></td>
          <!-- <td>
            <a key="aElement" :href="'#/OrderInfo?orderId=' + order.orderNb">
              <input type="button" class="btn btn-kne-orange pull-right" :value="$t('OrderCurrent.view')">
            </a>
          </td> -->
        </tr>
      </template>
    </table-element>
    </div>
  </div>
</template>

<script>
  import regularInput from '../module/basic-components/regularInput.vue'
  import regularSelect from '../module/basic-components/regularSelect.vue'
  import regularTextarea from '../module/basic-components/regularTextarea.vue'
  import regularCheckbox from '../module/basic-components/regularCheckbox.vue'
  import regularInputFile from '../module/basic-components/regularInputFile.vue'
  import {db, dbLogs} from '../../firebase'
  import Firebase from 'firebase'
  import regularDatalistDriver from '../module/basic-components/regularDatalistDriver.vue'
  import JsonExcel from 'vue-json-excel'
  import { ModelSelect } from 'vue-search-select'
  import TableElement from '../module/special-components/Table-component/Table-Element.vue'
  import LoadingRender from '../module/special-components/Other-components/LoadingRender.vue'
  import OrderStatusCounter from '../module/special-components/Other-components/OrderStatusCounter.vue'
  import CustomJsonExcel from '../module/special-components/Custom-packages/Custom-JsonExcel.vue'
  import 'vue-search-select/dist/VueSearchSelect.css'
  import { isRegularOrder } from '@/inventory/inventorySelectors'

  export default {
    name: 'Settings',
    components: {
      regularSelect,
      regularInput,
      regularInputFile,
      regularTextarea,
      regularCheckbox,
      TableElement,
    regularDatalistDriver,
    JsonExcel,
    ModelSelect,
    LoadingRender,
    OrderStatusCounter,
    CustomJsonExcel
    },

    data () {
      return {
        mode: 'settings',
        provinces: ['BC', 'ON', 'NL', 'NS', 'PE', 'NB', 'QC', 'MB', 'SK', 'AB', 'NT', 'NU', 'YT'],
        user: {
          name: '',
          address: '',
          city: '',
          zipCode: '',
          province: '',
          phone: '',
          nir: '',
          cigle: '',
          logo: ''
        },
        fuelCharge: 0,
        changePass: {
          email: '',
          oldPass: '',
          newPass: '',
          newPassConfirm: ''
        },
        geotabCredentials: {
          userName: '',
          password: '',
          database: ''
        },
        isZoneVerification: false,
        showPassword: false,
        announcementFR: '',
        announcementEN: '',
        isFeedbackPlay: false,
        feedbackMessage: '',
        // Logs data
        filterResults: [],
        search: {},
        paginate: ['filterResults'],
        fields: {
          userName: '',
          action: '',
          date: '',
          target: ''
        },
        logs: [],
        users: [],
        fieldsObj: [
          {
            text: this.$t('logs.table_header.user'),
            type: 'user',
            value: ''
          },
          {
            text: this.$t('logs.table_header.action'),
            type: 'action',
            value: ''
          },
          {
            text: this.$t('logs.table_header.date'),
            type: 'date',
            value: ''
          },
          {
            text: this.$t('logs.table_header.target'),
            type: 'target',
            value: ''
          }
        ],
        // Reports data
        reportsFeedbackMessage: '',
      orders: {
        deliveries: []
      },
      deliveries: [],
      vehicleCategories: {
        light: 'Light',
        medium: 'Medium',
        heavy: 'Heavy',
        extra_heavy: 'Extra Heavy',
        not_standard: 'Not Standard'
      },
      priceByVehicleClassification: {
        light: { volumetricLower: 0, volumetricUpper: 1599, realLower: 0, realUpper: 1599, surplus: 0 },
        medium: { volumetricLower: 1600, volumetricUpper: 2399, realLower: 1600, realUpper: 2399, surplus: 0 },
        heavy: { volumetricLower: 2400, volumetricUpper: 3199, realLower: 2400, realUpper: 3199, surplus: 0 },
        extra_heavy: { volumetricLower: 3200, volumetricUpper: 3999, realLower: 3200, realUpper: 3999, surplus: 0 },
        not_standard: { volumetricLower: 4000, volumetricUpper: 999999, realLower: 4000, realUpper: 999999, surplus: 0 }
      },
      customers_fields: {
        'Commande': 'orderNb',
        'Prix': 'price',
        'Livraison': 'delivery',
        'Cueillette': 'pickup',
        'Facturation': 'billing',
        'Status': 'status'
      },
      reportsSearch: {
        from: '',
        to: '',
        driver: '',
        driverUid: ''
      },
      reportsFieldsObj: [
       {
         text: this.$t('Reports.table.order'),
         type: 'orderNb',
         value: ''
       },
       {
         text: this.$t('Reports.table.price'),
         type: 'price',
         value: ''
       },
       {
         text: this.$t('Reports.table.pickup'),
         type: 'pickup',
         value: ''
       },
       {
         text: this.$t('Reports.table.delivery'),
         type: 'delivery',
         value: ''
       },
       {
         text: this.$t('Reports.table.billing'),
         type: 'billing',
         value: ''
       },
       {
         text: this.$t('Reports.table.status'),
         type: 'status',
         value: ''
       }
      ]
      }
    },

    mounted () {
      db.ref('users/transporters').child(this.companyUID).once('value').then((snapshot) => {
        this.$store.commit('setUserInfo', snapshot.val() || false)
        this.user = snapshot.val()
        this.geotabCredentials = snapshot.val().geotabCredentials || this.geotabCredentials
      })

      db.ref('users')
      .child('transporters')
      .child(this.companyUID)
      .child('priceByVehicleClassification')
      .once('value')
      .then((snapshot) => {
        const val = snapshot.val()
        if (val) {
          // Backward compatibility handle
          const updated = {}
          Object.keys(val).forEach(category => {
            const data = val[category]

            // if found old structure (only lowerLimit/upperLimit)
            if (data.lowerLimit !== undefined && data.upperLimit !== undefined) {
              updated[category] = {
                realLower: Number(data.lowerLimit),
                realUpper: Number(data.upperLimit),
                volumetricLower: Number(data.lowerLimit),
                volumetricUpper: Number(data.upperLimit),
                surplus: Number(data.surplus || 0)
              }
            } else {
              // if found new structure
              updated[category] = {
                realLower: Number(data.realLower || 0),
                realUpper: Number(data.realUpper || 0),
                volumetricLower: Number(data.volumetricLower || 0),
                volumetricUpper: Number(data.volumetricUpper || 0),
                surplus: Number(data.surplus || 0)
              }
            }
          })

          this.priceByVehicleClassification = updated
        } else {
          // If no data exists, initialize with default values and save them
          this.submitPriceByVehicleClassification()
        }
      })
      if (this.$store.state.searchLastPage !== 0) this.$refs.paginator.goToPage(this.$store.state.searchLastPage)
    },

    async created () {
      this.$bindAsObject('savedAnnouncements', db.ref('generalAnnouncement').child(this.uid))
      this.isLoading = true
      this.$store.state.isSidebarOpen = false

      if (this.isAdmin) {
        await this.$bindAsArray('logs', dbLogs.ref('logs/transporter/' + this.companyUID).limitToLast(2000))
        await this.$bindAsArray('users', db.ref('userInfos').child(this.companyUID))
      }
      this.$store.state.isSidebarOpen = false
    if (this.$store.state.search !== null) {
      const storedSearch = JSON.parse(JSON.stringify(this.$store.state.search))
      this.orders = {
        ...storedSearch,
        deliveries: (storedSearch.deliveries || []).filter(isRegularOrder)
      }
      this.reportsSearch = JSON.parse(JSON.stringify(this.$store.state.searchFields))
    }
    this.$bindAsArray('liste', db.ref('database/transporter/' + this.companyUID + '/liste'))
      this.isLoading = false
    },

    methods: {
      setMode (mode) {
        this.mode = mode
      },
      submitInfo: function () {
        db.ref('users/transporters').child(this.companyUID).update(this.user).then(() => {
          this.$store.commit('setUserInfo', this.user)
          // ======================== ADD COMPANY MODIFICATION LOG =======================
          this.$store.dispatch('newLog', {'UID': this.uid, 'action': 'COMPANY_MODIFY_INFO', 'date': Date.now()})
          // ======================== ADD COMPANY MODIFICATION LOG =======================
        })
      },

      submitPriceByVehicleClassification: function () {
        const obj = {}

        Object.keys(this.priceByVehicleClassification).forEach(category => {
          const data = this.priceByVehicleClassification[category]
          obj[category] = {
            realLower: Number(data.realLower || 0),
            realUpper: Number(data.realUpper || 0),
            volumetricLower: Number(data.volumetricLower || 0),
            volumetricUpper: Number(data.volumetricUpper || 0),
            surplus: Number(data.surplus || 0)
          }
        })

        db.ref('users')
          .child('transporters')
          .child(this.companyUID)
          .child('priceByVehicleClassification')
          .set(obj)
          .then(() => {
            this.$store.dispatch('newLog', {
              'UID': this.uid,
              'action': 'PRICE_CLASSIFICATION_UPDATE',
              'date': Date.now()
            })

            alert(this.$t('Settings.modifyPriceByVehicleClassification.success') || 'Price by vehicle classification saved')

            this.fetchAndUpdateUserInfo()
          })
          .catch(error => {
            console.error('Error saving vehicle classification prices:', error)
            alert(this.$t('Settings.modifyPriceByVehicleClassification.error') || 'Error saving prices')
          })
      },
      fetchAndUpdateUserInfo: function () {
        db.ref('users/transporters')
          .child(this.companyUID)
          .once('value')
          .then(snapshot => {
            const user = snapshot.val()
            if (user) {
              this.$store.commit('setUserInfo', user)
            }
          })
          .catch(error => {
            console.error('Error fetching user info:', error)
          })
      },
      submitGeotabCredentials: function () {
        db.ref('users/transporters').child(this.companyUID).child('geotabCredentials').set(this.geotabCredentials).then(() => {
          confirm('Geotab credentials saved')
        })
      },

      submitPass: function () {
        var user = Firebase.auth().currentUser
        var credential = Firebase.auth.EmailAuthProvider.credential(
          this.changePass.email,
          this.changePass.oldPass
          )
        user.reauthenticateWithCredential(credential).then(() => {
          user.updatePassword(this.changePass.newPass).then(() => {
            for (var attr in this.changePass) {
              this.changePass[attr] = ''
            }
            console.log('changed password')
          }).catch(function (error) {
            console.log(error)
          })
        }).catch(function (error) {
          console.log(error)
        })
      },

      changeLang: function (lang) {
        db.ref('users/transporters').child(this.companyUID).child('language').set(lang).then(() => {
          this.$store.commit('setUserLang', lang)
          this.$i18n.set(lang)
        })
      },

      toggleZoneVerification: function (verify) {
        db.ref('users/transporters').child(this.companyUID).child('isZoneVerification').set(verify).then(() => {
          this.$store.commit('setIsZoneVerification', verify)
          // this.isZoneVerification.set(verify)
        })
      },

      confirmeChangeToUserinfo: function () {
        db.ref('users/transporters').child(this.companyUID).child('fuelCharge').set(this.fuelCharge).then(() => {
          this.$store.commit('setFuelCharge', this.fuelCharge)
        })
      },

      onAnnouncementSave (announcementFR, announcementEN) {
        if (!this.isBothAnnouncementGucci) return

        db.ref('generalAnnouncement').child(this.uid).set({
          en: announcementEN,
          fr: announcementFR
        })

        this.playFeedback()
        this.clearAnnouncementTextbox()
      },

      playFeedback () {
        this.setFeedbackMessage('green', this.$t('Settings.modify_announcement.feedback_message'), true)

        this.toggleOffFeedback()
      },

      setFeedbackMessage (color, text, isTruthy) {
        document.getElementById('feedbackMessage').className = `text-center feedbackMessage_color_${color} mt-2`
        this.feedbackMessage = text
        isTruthy ? this.isFeedbackPlay = true : this.isFeedbackPlay = false
      },

      toggleOffFeedback () {
        setTimeout(() => {
          this.setFeedbackMessage('', '', false)
        }, 2000)
      },

      clearAnnouncementTextbox () {
        this.announcementFR = ''
        this.announcementEN = ''
      },
      // Logs methods
      updateFilterResults (sortResults) {
      this.filterResults = sortResults
    },

    setLastPage (toPage, fromPage) {
      this.$store.commit('SET_LAST_PAGE', toPage)
    },

    getUserName (uid) {
      if (uid === this.companyUID) return this.$t('logs.admin')
      let user = this.users.find((u) => {
        return u['.key'] === uid
      })
      return user ? user.firstName + ' ' + user.lastName : ''
    },
    // Report methods
    // Report methods
    /** On user begins search, fetch orders */
    async onSearchSubmit () {
      this.isLoading = true
      this.orders.deliveries = []
      this.deliveries = []

      await this.setDriverOrders()
      await this.setDriverOrdersOther()

      this.reportsFeedbackMessage = ''
      this.isLoading = false
    },

    /** These are orders that have been completed (Finished) by the driver */
    async setDriverOrders () {
      var resData = []
      let query = this.setQuery()

      await window.axios.get('https://archivesapi.keepneye.com/search/decode/search/' + this.companyUID + '/' + query).then((response) => {
        const regularResults = {
          ...(response.data || {}),
          deliveries: ((response.data && response.data.deliveries) || []).filter(isRegularOrder)
        }
        this.$store.commit('SET_LAST_PAGE', 0)
        this.$store.commit('STORE_SEARCH', regularResults)
        this.$store.commit('STORE_SEARCH_FIELD', this.reportsSearch)

        resData = regularResults.deliveries
      }).catch((error) => {
          console.log('Error 1', error)
          this.reportsFeedbackMessage = this.$t('Reports.error_loading_orders')
          this.isLoading = false
        })

      this.isLoading = false
      this.deliveries = resData
    },

    /** These are orders that are not completed yet (Not finished lul) by the driver */
    async setDriverOrdersOther () {
      var resData = {}

      let minTime = this.getTimestamp(this.reportsSearch.from)
      let maxTime = this.getTimestamp(this.reportsSearch.to) + 86400000

      await db.ref('database').child('transporter').child(this.companyUID).child('deliveries').orderByChild('creationDate').startAt(minTime).endAt(maxTime).once('value').then((response) => {
        resData = response.val() || {}
        // let count = 0

        for (const [key, value] of Object.entries(resData)) {
          if (isRegularOrder(value) && value.driverName !== null && value.driverName !== '' && value.driverName === this.reportsSearch.driver) {
            // count++
            const obj = {
              'orderNb': key,
              'price': value.price,
              'delivery': this.$realName(value, 'receiver'),
              'pickup': this.$realName(value, 'transmitter'),
              'billing': this.$realName(value, 'payer'),
              'status': value.status
            }
            this.deliveries.push(obj)
          }
        }
      }).catch((error) => {
          console.log('Error 2', error)
          this.reportsFeedbackMessage = this.$t('Reports.error_loading_orders')
          this.isLoading = false
        })

      this.isLoading = false
    },

    /** Set the query string for the Axios request */
    setQuery () {
      let query = ''
      let maxTime = this.getTimestamp(this.reportsSearch.to) + 86400000
      if (this.reportsSearch.from !== '') query = query + 'from=' + Date.parse(this.reportsSearch.from) + '&'
      if (this.reportsSearch.to !== '') query = query + 'to=' + maxTime + '&'
      if (this.reportsSearch.driver !== '') query = query + 'driver=' + this.reportsSearch.driver
      console.log('dteat', this.reportsSearch)
      return query
    },

    getTimestamp (receivedDate) {
      let timestamp = Date.parse(receivedDate)
      return timestamp
    },

    getDate (timestamp) {
      var date = new Date(timestamp)
      return date.toLocaleDateString() + ' ' + date.toLocaleTimeString('en-US', {timeZone: 'America/New_York'})
    },

    clear () {
      for (var attr in this.reportsSearch) {
        this.reportsSearch[attr] = ''
      }

      this.orders.deliveries = []
      this.deliveries = []
      this.$store.commit('CLEAR_SEARCH')
    },

    // Return properly translated status because this is coded very well smile :)
    translatedStatus (transgenderStatus) {
      let status = transgenderStatus

      switch (status) {
        case 'Processing':
          status = 'processing'
          break

        case 'Dispatch':
          status = 'dispatch'
          break

        case 'Drop':
          status = 'Drop'
          break

        case 'Pick':
          status = 'Pick'
          break

        case 'Attente':
          status = 'waiting'
          break

        case 'Transit':
          status = 'transit'
          break

        case 'Inspection':
          status = 'inspection'
          break

        case 'Transférée':
          status = 'transfered'
          break

        case 'Reject':
          status = 'rejected'
          break

        case 'Cancel':
          status = 'canceled'
          break

        case 'Terminée':
          status = 'finished'
          break

        default: status = 'unknown'
          break
      }
      status = status.toLowerCase()
      return this.$t(`Search.status.${status}`)
    }
    },

    computed: {
      modifyFormFilled: function () {
        return this.user.name !== '' && this.user.address !== '' && this.user.city !== '' && this.user.zipCode !== '' && this.user.province !== '' && this.user.phone !== '' && this.user.NIR !== '' && this.user.cigle !== ''
      },
      modifyPasswordFormFilled: function () {
        return this.changePass.newPass !== '' && this.changePass.newPassConfirm !== ''
      },
      passwordConfirmation: function () {
        if (this.changePass.newPass === '') return false
        else if (this.changePass.newPass === this.changePass.newPassConfirm) return true
        else return false
      },
      modifyGeotabCredentials: function () {
        return (!this.geotabCredentials.userName || !this.geotabCredentials.password || !this.geotabCredentials.database)
      },
      hasFullAccess () {
        return this.$store.state.userInfo.userType === 'full'
      },
      userInfo () {
        return this.$store.state.userInfo
      },
      companyUID () {
        return this.$store.state.authorization.company
      },
      isAdmin () {
        return this.$store.state.authorization.role === 'Admin'
      },
      isViewer () {
        return this.$store.state.authorization.role === 'Viewer'
      },
      uid () {
        return this.$store.state.user.uid
      },

      isBothAnnouncementGucci () {
        if (this.announcementFR !== '' && this.announcementEN !== '') {
          this.setFeedbackMessage('green', this.$t('Settings.modify_announcement.feedback_message'), true)
          return true
        } else {
          this.setFeedbackMessage('red', this.$t('Settings.modify_announcement.feedback_message_error'), true)
          return false
        }
      },
      reversedLogs () {
      return this.logs.slice().reverse()
    },
    computed_newCount (newCount) {
      return newCount
    },

    getDriverSelectOptions () {
      if (!this.liste) return
      let driverArray = []

      this.liste.forEach((driver) => {
        driverArray.push({
          value: driver['.value'],
          text: driver['.value'],
          uid: driver['.key']
        })
      })

      return driverArray
    },

    filled () {
      return this.reportsSearch.from !== '' && this.reportsSearch.to !== '' && this.reportsSearch.driver !== ''
    },
    driverUid () {
      let driverID = ''
      driverID = this.liste.find(driver => driver['.value'] === this.reportsSearch.driver)

      return driverID['.key']
    }
    }
  }
  </script>

  <style scoped>
  .card-header{
    border-bottom: 3px solid #f7941e;
  }
  @media (max-width: 991px) {
    #changePass{
      margin-top: 1rem;
    }
  }
  .btn-kne-darkgrey{
    background-color: #2c2d2f !important;
    border-color: #2c2d2f !important;
    color: rgba(255,255,255,.5) !important;
    cursor: pointer;
  }
  .btn-kne-darkgrey:hover{
    color: rgba(255,255,255,.75) !important;
  }
  #logo{
    height: 10rem;
  }

  .feedbackMessage_color_green {
    color: rgb(0, 200, 0);
  }

  .feedbackMessage_color_red {
    color: rgb(200, 0, 0);
  }

  .password-group {
    display: flex;
  }

  .input-password {
    flex: 2;
  }

  .eye-button,
  .eye-button:active,
  .eye-button:focus  {
    width: 37px;
    border: 1px solid rgba(0,0,0,.15);
    border-left: none;
    border-radius: 0.25rem;
    background: none;
    outline: none;
  }
  .vehicle-classification-item{
    display: flex;
    gap: 1rem;
    align-items: center;
  }
  .table thead th{
  border-bottom: 1px solid #eceeef;
  border-top: none;
}
input, button{
  cursor: pointer;
}
#addOrder{
  position: fixed;
  right: 1rem;
  bottom: 1rem;
}
/* Reports styles */
input, button {
    cursor: pointer;
  }

  .date_search-container {
    display: flex;
  }

  .search_element-container {
    display: flex;
    flex-flow: column;
  }
  .button_search_container {
    display: flex;
    flex-flow: row;
    justify-content: center;
  }
  
  .search_field {
    margin: 0px 47px 0px 47px;
  }

  @media (max-width: 767px) {
    .search-wrapper {
      display: flex;
      flex-flow: column;
    }
    .date_search-container {
      display: block;
    }
    .button_search_container {
      display: block
    }
    .search_element-container {
      display: block;
    }
  }
  </style>
